export default {

    indexGroupIdentifiers:  { method: 'get',    url: 'group_identifiers' },
    storeGroupIdentifier:   { method: 'post',   url: 'group_identifiers' },
    updateGroupIdentifier:  { method: 'put',    url: 'group_identifiers/{id}'},
    destroyGroupIdentifier: { method: 'delete', url: 'group_identifiers/{id}'},

}